'use client'
import { ScrollRow } from '@/components/ScrollRow/ScrollRow'
import type { ExpectedBlockType, SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { StoryblokComponent, storyblokEditable } from '@storyblok/react'
import type { ImageBlockProps } from './ImageBlock/ImageBlock'
import type { VideoBlockProps } from './VideoBlock'
import { wrapper } from './MediaListBlock.css'

const playVideoExclusively = (videoList: Array<HTMLVideoElement>, videoToBePlayed: HTMLVideoElement) => {
  videoList.forEach((videoNode) => {
    if (videoNode === videoToBePlayed) return
    if (videoNode.played.length > 0 && !videoNode.paused) {
      videoNode.pause()
    }
  })
}

type MediaListBlockProps = SbBaseBlockProps<{
  media: ExpectedBlockType<VideoBlockProps | ImageBlockProps>
}>

export const MediaListBlock = ({ blok }: MediaListBlockProps) => {
  return (
    <ScrollRow
      ref={(node) => {
        const videos = Array.from(node?.querySelectorAll('video') ?? [])

        videos.forEach((video) => {
          video.addEventListener('play', () => playVideoExclusively(videos, video))
        })
      }}
      alignment="center"
      {...storyblokEditable(blok)}
    >
      {blok.media.map((nestedBlok) => (
        <div key={nestedBlok._uid} className={wrapper}>
          <StoryblokComponent blok={nestedBlok} nested={true} />
        </div>
      ))}
    </ScrollRow>
  )
}
